import { AsideMenuHyperLink } from "../../../../layout/components/aside/AsideMenuItem"
import { IPageAction } from "../../../base/models"
import { useUmsUrl } from "../services/useTouUrl"

export const AsideMenuUMSLink = ({ action, hasBullet, className }: {
    action: IPageAction,
    hasBullet: boolean
    className?: string
}) => {
    const { umsUrl } = useUmsUrl()

    if (!umsUrl)
        return <></>

    return (
        <AsideMenuHyperLink
            hasBullet={hasBullet}
            className={className}
            to={umsUrl}
            materialIcon={action.icon}
            title={action.name}
            fontIcon='bi-app-indicator'
        />)
}